import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import FormGroupWrapper from "../Wrappers/FormGroupWrapper";
import { formGroupCodeDefaultProps, formGroupCodePropTypes, renderFormGroupCommonPropTypes } from "../FormGroupCommonPropTypes";
var RenderCode = function RenderCode(props) {
  var input = props.input,
    type = props.type,
    autocomplete = props.autocomplete,
    autofocus = props.autofocus,
    maxLength = props.maxLength;
  return /*#__PURE__*/React.createElement(FormGroupWrapper, props, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    id: input.name,
    type: type,
    className: "code-input",
    autoComplete: autocomplete,
    autoFocus: autofocus // eslint-disable-line jsx-a11y/no-autofocus
    ,
    maxLength: maxLength
  })));
};
RenderCode.propTypes = _objectSpread(_objectSpread({}, renderFormGroupCommonPropTypes), formGroupCodePropTypes);
RenderCode.defaultProps = _objectSpread({}, formGroupCodeDefaultProps);
export default RenderCode;